import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlContrato = '/service/materiais/contrato/'

class DetalhesContratoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }

        return this.conex.post(urlContrato + 'detalhesContrato/', JSON.stringify(data))
    }
}

export default DetalhesContratoService
